import { Link } from "react-router-dom";
import { ShareIcon } from "../icons.js";

/**
 * Share icon + count of live guest shares reaching a page or directory
 * (docs/auth/Shares.md) → `/_share` for it. Rendered only when the page
 * response carries `shares` (the user may share here).
 */
export function ShareBadge({
  repo,
  path,
  dir,
  count,
}: {
  repo: string;
  /** Repo-relative URL path of the page / directory. */
  path: string;
  dir: boolean;
  count: number;
}) {
  const q = new URLSearchParams({ repo, path, ...(dir ? { dir: "1" } : {}) });
  const label = count ? `Shared with ${count}` : "Share";
  return (
    <Link className="dw-share-badge" to={`/_share?${q.toString()}`} title={label}>
      <ShareIcon />
      <span>{count ? count : "share"}</span>
    </Link>
  );
}
